export const priceList = [
    {
        id: 0,
        value: '指定なし',
    },
    {
        id: 3,
        value: '300万'
    },
    {
        id: 5,
        value: '500万'
    },
    {
        id: 8,
        value: '800万'
    },
    {
        id: 10,
        value: '1000万'
    },
    {
        id: 20,
        value: '2000万'
    },
    {
        id: 30,
        value: '3000万'
    },
    {
        id: 40,
        value: '4000万'
    },
    {
        id: 50,
        value: '5000万'
    },
    {
        id: 60,
        value: '6000万'
    },
    {
        id: 70,
        value: '7000万'
    },
    {
        id: 80,
        value: '8000万'
    },
    {
        id: 90,
        value: '9000万'
    },
    {
        id: 100,
        value: '1億'
    },
    {
        id: 200,
        value: '2億'
    },
    {
        id: 300,
        value: '3億'
    }
]